import { INIT_RESTAURANT } from './actions';

const initialState = {

};

const reducer = (state = initialState, action) => {

    switch (action.type) {
        case INIT_RESTAURANT: {

            return {
                ...state,
                data: action.data
            }
        }

        default: {
            return state
        };
    }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/services/store/reducers/restaurant/index.js